import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import ChevronDownIcon from '@mui/icons-material/KeyboardArrowDown'
import Menu from '@mui/material/Menu'

import axios from '../../dataClient/dataClient'
import { theme } from '../../themes/theme'
import { ErrorText, SmallBodyText } from '../styles/Text'
import { FlexRow } from '../styles/Containers'
import { SelectMenuItem } from '../styles/TextField'
import Button from '../common/Button'

const StyledButton = styled(Button)`
  gap: 10px;
  .MuiSvgIcon-root {
    transform: scale(1.5);
    transform-origin: center;
  }
`

const Separator = styled.span`
  width: 1px;
  height: 15px;
  background: ${theme.colors.primaryButton.text};
  opacity: 0.6;
`

const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    min-width: 200px;
    border-radius: 5px;
    background-color: ${theme.colors.background.medium};
    box-shadow: none;
  }

  .MuiList-root {
    padding: 5px 0;
  }
`

const MenuItem = styled(SelectMenuItem)`
  &&:hover {
    background-color: ${theme.colors.primaryLight};
  }
`

function CreateDraftCommunicationFromTemplateButton({ foiId, communicationTemplates, handleCreateDraft = () => {} }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const handleClick = event => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  function handleSelect(id) {
    setError(false)
    setIsLoading(true)
    handleClose()

    axios
      .post(`/communication/communication-template/${id}/convert-to-draft`, { foiId })
      .then(({ data }) => handleCreateDraft(data.data))
      .catch(e => {
        console.error('Failed to create draft from template', id, e)
        setError(true)
      })
      .finally(() => setIsLoading(false))
  }

  function createBlankDraft() {
    setError(false)
    setIsLoading(true)
    handleClose()

    axios
      .post('/communication', { foiId })
      .then(({ data }) => handleCreateDraft(data.data))
      .catch(e => {
        console.error('Failed to create blank draft', e)
        setError(true)
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <>
      <StyledButton onClick={handleClick} aria-haspopup="true" aria-expanded={open} loading={isLoading}>
        Create
        <Separator />
        <ChevronDownIcon />
      </StyledButton>
      <StyledMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}>
        <MenuItem key="blank-template" onClick={createBlankDraft}>
          Blank
        </MenuItem>
        {communicationTemplates.length > 0 && (
          <FlexRow padding="5px 10px 0">
            <SmallBodyText>From Template</SmallBodyText>
          </FlexRow>
        )}
        {communicationTemplates.map(template => (
          <MenuItem key={template.id} onClick={() => handleSelect(template.id)}>
            {template.name}
          </MenuItem>
        ))}
      </StyledMenu>
      {error && <ErrorText role="alert">There was an error. Please try again.</ErrorText>}
    </>
  )
}

CreateDraftCommunicationFromTemplateButton.propTypes = {
  foiId: PropTypes.string.isRequired,
  communicationTemplates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  handleCreateDraft: PropTypes.func
}

export default CreateDraftCommunicationFromTemplateButton
